import { render, staticRenderFns } from "./ChatbotThreadsTable.vue?vue&type=template&id=23c266ee&"
import script from "./ChatbotThreadsTable.vue?vue&type=script&lang=js&"
export * from "./ChatbotThreadsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports